import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showError } from '../../actions/uiActions';
import './fax.css';
import faxApi from '../../api/fax';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Preview from '@mui/icons-material/FindInPage';
import Loading from '../../components/Loading/index';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import FaxPreview from './FaxPreview';
import PaginatedTable from '../../components/PaginatedTable/index';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import Cancel from '@mui/icons-material/Cancel';

class GetFax extends React.Component {
  state = {
    faxes: [],
    loading: false,
    error: false,
    faxDetails: null,
    previewing: false,
    page: 0,
    count: 0,
    search: '',
  };

  componentDidMount() {
    this.getFaxes(0);
  }

  getFaxes = async (page = 0) => {
    try {
      this.setState({
        loading: true,
        searching: this.state.search ? true : false,
      });
      const result = await faxApi.getFax(page, this.state.search);
      this.setState({ ...result, loading: false });
    } catch (error) {
      this.setState({ error: true, loading: false });
      this.props.showError(error);
    }
  };

  renderLoading() {
    return (
      <TableCell colSpan={6} align='center'>
        <LinearProgress className='progressbar' color='primary' />
      </TableCell>
    );
  }

  renderEmptyState(error = false) {
    return (
      <TableCell colSpan={6} align='center'>
        {error ? 'Error fetching faxes, please try again' : 'No Faxes'}
      </TableCell>
    );
  }

  openPreview = async (id) => {
    try {
      this.setState({ previewing: true });
      const request = await faxApi.getFaxById(id);
      this.setState({ faxDetails: request, previewing: false });
    } catch (error) {
      this.setState({ previewing: false });
      this.props.showError(error);
    }
    this.setState({ preview: true });
  };

  render() {
    return (
      <>
        <div className='animated fadeIn'>
          <div className='fax-m-12'>
            <h4>Sent Fax</h4>
            <p>These are the list of one-off faxes that have been sent out</p>
            <div className='row'>
              <div className='col-6'>
                <Paper
                  style={{ display: 'flex', marginBottom: '20px' }}
                  elevation={1}
                >
                  <InputBase
                    onKeyDown={(e) => {
                      if (e.keyCode == 13) this.getFaxes(0);
                    }}
                    disabled={this.state.searching}
                    value={this.state.search}
                    onChange={(e) => this.setState({ search: e.target.value })}
                    placeholder='Search Fax...'
                    style={{ width: '90%', padding: '13px' }}
                  />
                  {this.state.searching && (
                    <IconButton
                      onClick={() =>
                        this.setState({ searching: false, search: '' }, () =>
                          this.getFaxes(0)
                        )
                      }
                      aria-label='Clear'
                    >
                      <Cancel />
                    </IconButton>
                  )}
                  <Divider
                    style={{
                      width: 1,
                      height: 34,
                      margin: 4,
                    }}
                  />
                  <IconButton
                    onClick={() => this.getFaxes(0)}
                    aria-label='Search'
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>
            </div>
            <Paper>
              <PaginatedTable
                goToPage={this.getFaxes}
                count={parseInt(this.state.count.toString())}
                page={parseInt(this.state.page.toString())}
                loading={this.state.loading}
                rows={this.state.faxes.map((fax) => {
                  return {
                    properties: {
                      key: fax._id,
                    },
                    columns: [
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: fax.date,
                      },
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: fax.sender[0] ? fax.sender[0].name : "Unknown" ,
                      },
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: fax.from,
                      },
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: fax.to,
                      },
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: fax.status,
                      },
                      {
                        properties: {
                          key: `${fax._id}`,
                        },
                        value: (
                          <>
                            {this.state.previewing ? (
                              <CircularProgress size={20} />
                            ) : (
                              <Tooltip title='Preview Form'>
                                <IconButton
                                  onClick={() => this.openPreview(fax._id)}
                                >
                                  <Preview />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        ),
                      },
                    ],
                  };
                })}
                emptyMessage='No fax has been sent'
                columns={[
                  {
                    name: 'Date',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                  {
                    name: 'Sender',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                  {
                    name: 'From',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                  {
                    name: 'To',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                  {
                    name: 'Status',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                  {
                    name: 'Preview',
                    properties: {
                      key: 1,
                      className: 'width10pct',
                    },
                  },
                ]}
              />
            </Paper>
          </div>
        </div>
        {this.state.faxDetails && (
          <FaxPreview
            open={this.state.faxDetails}
            onClose={() => this.setState({ faxDetails: null })}
            data={this.state.faxDetails}
          />
        )}
      </>
    );
  }
}

export default connect(null, {
  showError,
})(GetFax);
